import React, { useState } from 'react'
import Sidebar from '../SideBar/index'
import Navbar from '../Navbar/index'
import "./Hero.css"

const HeroSection = () => {
   const [isOpen, setIsOpen] = useState(false)
    
   const toggle = () => {
    setIsOpen(!isOpen)
   }
  return (
    <>
    <div className='HeroContainer'>
      <Sidebar isOpen={isOpen} toggle={toggle}/>
        <div className='HeroBg'>
          <Navbar toggle={toggle}/>
        </div>
    </div>
    </>
  )
}

export default HeroSection